import React from 'react';

const SvgLb = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="LB_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="LB_svg__b" fill="#fff">
        <use xlinkHref="#LB_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path
        fill="#F03340"
        mask="url(#LB_svg__b)"
        d="M0 0h28v5.333H0zM0 14.667h28V20H0z"
      />
      <path
        d="M12.867 12.466a.663.663 0 0 0-.004-.936l.274.274c-.26-.26-.756-.4-1.116-.31l-1.375.345c-.357.089-.4-.024-.106-.244l1.587-1.19c.298-.224.245-.405-.126-.405h-.668c-.368 0-.4-.133-.075-.296l1.484-.741c.326-.164.296-.296-.075-.296H12c-.368 0-.42-.185-.126-.405l1.587-1.19c.298-.224.786-.22 1.08 0l1.587 1.19c.298.223.245.405-.126.405h-.668c-.368 0-.4.132-.075.296l1.484.741c.326.164.296.296-.075.296H16c-.368 0-.42.185-.126.405l1.587 1.19c.298.224.255.334-.106.244l-1.375-.344c-.357-.09-.857.05-1.116.309l.274-.274a.662.662 0 0 0-.004.936l.4.401c.258.258.166.466-.194.466h-2.678c-.365 0-.453-.208-.195-.466l.401-.4z"
        fill="#1FC065"
        mask="url(#LB_svg__b)"
      />
    </g>
  </svg>
);

export default SvgLb;
